import { render } from "./PixelGrid.vue?vue&type=template&id=4e9695d4&scoped=true"
import script from "./PixelGrid.vue?vue&type=script&lang=js"
export * from "./PixelGrid.vue?vue&type=script&lang=js"

import "./PixelGrid.vue?vue&type=style&index=0&id=4e9695d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9695d4"]])

export default __exports__